/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import axios from "axios";
import {
    Connection,
    ConnectionTypes,
} from "../../rest/dto/datasources.interfaces";

export const isLocalhost = (): boolean =>
    window.location.hostname === "localhost";

export const checkIfNewQueryConsoleAvailable = async (): Promise<boolean> => {
    if (isLocalhost()) {
        return false;
    }

    const queryConsolePingUrl = `${window.location.origin.replace(
        "data.",
        ""
    )}/api/v1/query-console/runtime`;

    try {
        const resp = await axios.get(queryConsolePingUrl);
        if ([200, 401].includes(resp.status) && typeof resp.data === "object") {
            return true;
        }

        return false;
    } catch (error) {
        return false;
    }
};

export const getQueryConsoleUrl = (
    defaultPinotDatasource: Connection | null,
    accessToken: string,
    goToStarTreeQueryConsole: boolean
): string | null => {
    if (isLocalhost()) {
        return null;
    }

    if (goToStarTreeQueryConsole) {
        return `${window.location.origin.replace(
            "data.",
            ""
        )}/query-console#access_token=${accessToken}`;
    }

    const ossQueryConsoleUrl =
        defaultPinotDatasource?.connection?.controllerExternalUrl;

    if (ossQueryConsoleUrl) {
        return `${ossQueryConsoleUrl}#access_token=${accessToken}&query`;
    }

    return null;
};

export const getMyAppsClientsPageUrl = (accessToken: string): string => {
    const myAppsOriginUrl = window.location.origin.replace("data.", "apps.");
    const myAppsClientsPageUrl = `${myAppsOriginUrl}/clients?access_token=${accessToken}`;

    return myAppsClientsPageUrl;
};

export const getDefaultPinotDatasource = (
    datasources: Connection[]
): Connection | undefined => {
    const defaultPinotDatasource = datasources.find(
        (datasource) => datasource && datasource.type === ConnectionTypes.PINOT
    );

    return defaultPinotDatasource;
};
